import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-delegate-rights',
  templateUrl: './delegate-rights.component.html',
  styleUrls: ['./delegate-rights.component.scss']
})
export class DelegateRightsComponent implements OnInit {

  constructor() { }

  @Input() public rights: string;
  
  ngOnInit() {
  }

}
